import {
    previewContainer,
    previewDisplayText,
} from 'owa-mail-listitem-styles/lib/scss/MailListItem.scss';
import classnames from 'owa-classnames';
import { tokens } from '@fluentui/react-components';
import { observer } from 'owa-mobx-react';
import { highlightTermsInHtmlElement } from 'owa-highlight';
import { useMessageListTextStyle } from 'owa-mail-listitem-styles/lib/utils/useMessageListTextStyle';
import type { Accuracy } from 'owa-mark/lib/utils/markElements';
import React from 'react';
import CopilotPrioritizeOnboardedCallout from './CopilotPrioritizeOnboardedCallout';
import { getStore as getMailListStore } from 'owa-mail-list-store';
import type { MailboxInfo } from 'owa-client-types';
import { isPrioritizeOnDeliveryOn } from 'owa-copilot-settings-utils';

export interface MailListItemPreviewDisplayProps {
    highlightTerms: string[];
    previewDisplay: string;
    highlightAccuracy?: Accuracy;
    rowId: string;
    mailboxInfo: MailboxInfo;
    isSelected: boolean;
    cfTextStyle?: React.CSSProperties;
}

const defaultExport: React.FunctionComponent<MailListItemPreviewDisplayProps> = observer(
    function MailListItemPreviewDisplay(props: MailListItemPreviewDisplayProps) {
        const {
            highlightTerms,
            previewDisplay,
            highlightAccuracy,
            rowId,
            cfTextStyle,
            isSelected,
        } = props;
        const rowRef = React.useRef<HTMLDivElement>(null);
        const targetRowId = getMailListStore().copilotPrioritizeOnboardedCalloutTarget;

        const highLightTerms = React.useCallback(
            (element: HTMLElement) => {
                highlightTermsInHtmlElement(
                    element,
                    highlightTerms,
                    false /* separateWordSearch */,
                    highlightAccuracy /* highlightAccuracy */
                );
            },
            [highlightTerms, highlightAccuracy]
        );

        const textStyle = React.useMemo(() => {
            if (cfTextStyle) {
                const baseColor = isSelected
                    ? tokens.colorNeutralForeground2
                    : tokens.colorNeutralForeground3;

                return {
                    color: `var(--cfHoverTextColorOverride, ${baseColor})`,
                };
            }
            return {};
        }, [cfTextStyle, isSelected]);

        return (
            <div className={previewContainer} ref={rowRef}>
                <span
                    className={classnames(previewDisplayText, useMessageListTextStyle('Major'))}
                    ref={highLightTerms}
                    style={textStyle}
                >
                    {previewDisplay}
                </span>
                {isPrioritizeOnDeliveryOn(props.mailboxInfo) && targetRowId === rowId && (
                    <CopilotPrioritizeOnboardedCallout
                        target={rowRef}
                        id="CopilotPrioritizeOnboarded"
                    />
                )}
            </div>
        );
    },
    'MailListItemPreviewDisplay'
);
export default defaultExport;
